import {
  BROADCAST_INITIALIZING_SOURCE,
  BROADCAST_UPDATE_PROGRAM_INITIALIZING_STATE
} from 'actions/Types';

/**
 * @param {string} sourceIdOrValue id / value of the source to set initialization state
 * When passing the the value, the 3rd arg should be a boolean
 */
export default (
  sourceIdOrValue,
  { isInitializing = false, isAttendee = true, presenterSessionId }
) => {
  return (dispatch, getState) => {
    const {
      broadcastSources: { sources },
      program
    } = getState();
    let sourceToUpdate = sourceIdOrValue;
    let shouldInitializeSource = true;
    if (isAttendee) {
      const source = sources.find(src => src.value === sourceIdOrValue);
      if (source) {
        sourceToUpdate = source._id;
        shouldInitializeSource = source.isInitializing !== isInitializing;
      }
    }
    const payload = {
      sourceId: sourceToUpdate,
      isInitializing: isInitializing,
      ...(presenterSessionId !== undefined && { presenterSessionId })
    };

    if (shouldInitializeSource) {
      dispatch({ type: BROADCAST_INITIALIZING_SOURCE, payload });

      const isSourceInProgram = program.layers.find(
        layer =>
          layer.source.value === sourceToUpdate ||
          layer.source._id === sourceToUpdate
      );

      if (isSourceInProgram) {
        dispatch({
          type: BROADCAST_UPDATE_PROGRAM_INITIALIZING_STATE,
          payload
        });
      }
    }

    return true;
  };
};
